/**
 * Who may do what with customers, from the permissions at the store in view.
 * The server checks the same (customers:read / customers:manage at the
 * location; account and system admins pass), these only decide what to show.
 */
import { isSystemOrAccountAdmin } from '@turn-connect/hooks';

type Perms = readonly string[] | null | undefined;

const list = (p: Perms): string[] => (p ? [...p] : []);

/** See customers and their jobs (the Customers tab). */
export function canReadCustomers(permissions: Perms): boolean {
  const p = list(permissions);
  return isSystemOrAccountAdmin(p) || p.includes('customers:read');
}

/** Add, edit and archive customers, and set a work order's customer. */
export function canManageCustomers(permissions: Perms): boolean {
  const p = list(permissions);
  return isSystemOrAccountAdmin(p) || p.includes('customers:manage');
}

/** Switch the module on or off: whoever may edit the account's details. */
export function canSwitchCustomers(permissions: Perms): boolean {
  const p = list(permissions);
  return isSystemOrAccountAdmin(p) || p.includes('accounts:update');
}
